module.exports = __webpack_public_path__ + "img/ico-15.4370dfa6.svg";